import { costParts, costSentence } from "../format";
import type { OptionCost } from "../types";

/** IN/ON tag: colour + pattern + text label, never colour alone (19 §7.3). */
export function TimeTag({ kind }: { kind: "in" | "on" }) {
  return <span className={`time-tag time-tag--${kind}`}>{kind === "on" ? "ON" : "IN"}</span>;
}

/** What the player can realistically know about an option's cost (19 §4.2). No hidden effects. */
export function CostPreview({ cost }: { cost: OptionCost }) {
  const p = costParts(cost);
  return (
    <span className="cost">
      <span className="visually-hidden">{costSentence(cost)}</span>
      <span className="cost__visible" aria-hidden="true">
        {p.time && <span className="cost__time">{p.time}</span>}
        <TimeTag kind={p.kind} />
        {p.pc && (
          <span className="cost__pc" title={`${p.pc === "significant" ? "Significant" : "Some"} political cost`}>
            <span className="cost__glyph">{p.pc === "significant" ? "◑" : "◔"}</span> {p.pc === "significant" ? "significant" : "some"} political
          </span>
        )}
        {p.en && <span className="cost__en">{p.en}</span>}
      </span>
    </span>
  );
}
